import { BRAND } from '@legate/shared';
import { Section } from './Section.js';

const ANTI_GOALS = [
  'We do not claim partnerships, investors or customers that do not exist.',
  'We do not automate cold DMs around the Platform Terms.',
  'We do not buy or scrape employee personal data.',
  'We do not hide that the agent is an agent where disclosure is required or requested.',
  'We do not promise token holders income.',
];

const CHAIN_FACTS: { term: string; value: string }[] = [
  { term: 'Chain', value: BRAND.chain },
  { term: 'Chain ID', value: '4663' },
  { term: 'Token', value: BRAND.ticker },
  { term: 'Launchpad', value: BRAND.launchpad },
  { term: 'Supply', value: 'Fixed' },
  { term: 'Liquidity', value: 'LP locked permanently' },
];

export function CompanySection() {
  return (
    <Section
      id="company"
      label="Company"
      title={
        <>
          What we will
          <br className="hidden sm:block" /> not do
        </>
      }
      intro="The constraints are the product. They are written down here so they can be held against us, and they are enforced in the runtime rather than in a policy page."
    >
      <ol className="divide-y divide-hairline border-t border-hairline">
        {ANTI_GOALS.map((line, index) => (
          <li key={line} className="flex items-baseline gap-4 py-5">
            <span className="text-sm text-ink/40 tabular w-6 shrink-0">
              {String(index + 1).padStart(2, '0')}
            </span>
            <span className="text-sm md:text-[15px] text-ink/70 leading-relaxed">{line}</span>
          </li>
        ))}
      </ol>

      <div className="mt-14 sm:mt-16">
        <div className="text-[11px] uppercase tracking-[0.2em] text-ink/50 font-medium">
          Chain facts
        </div>
        <dl className="mt-6 divide-y divide-hairline border-t border-hairline">
          {CHAIN_FACTS.map((fact) => (
            <div key={fact.term} className="flex items-baseline justify-between gap-6 py-4">
              <dt className="text-sm text-ink/50">{fact.term}</dt>
              <dd className="text-sm font-medium text-ink tabular text-right">{fact.value}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-6 max-w-2xl text-sm text-ink/50 leading-relaxed">
          {BRAND.ticker} pays for credits at a discount and unlocks product limits through staking.
          It is not a claim on revenue and carries no promise of return.
        </p>
      </div>
    </Section>
  );
}

export default CompanySection;
